/* global $:false */
(function() {
  "use strict";

  angular
    .module("admin.collector_levels.edit", [])
    .controller("CollectorLevelsEditCtrl", CollectorLevelsEditCtrl);

  /** @ngInject */
  function CollectorLevelsEditCtrl($state, $q, $timeout, $stateParams, CollectorLevelService, UploadService, TranslatorService) {
    var vm = this;

    vm.model = {};
    vm.pathImgH = "";
    vm.id = $stateParams.id;
    vm.title = ''

    CollectorLevelService.list().then(function(result) {
      var level = _.find(result.results, { id: parseInt(vm.id) })
      if (!level.img) {
        level.img = "";
      }
      vm.model = level;
      vm.title = vm.model.t;
    });

    vm.save = function() {
      var model = angular.copy(vm.model);
      delete model.ts;
      delete model["ts-p"];

      if (!model.t) {
        swal("Title field is required.", "", "error");
        return;
      }

      if (!model.img) {
        swal("Image field is required.", "", "error");
        return;
      }

      if (!model['color-fill']) {
        swal("Color field is required.", "", "error");
        return;
      }

      if (model['cv-min'] === null && model['cv-min'] === undefined) {
        swal("CV field is required.", "", "error");
        return;
      }

      CollectorLevelService.update(model.id, model).then(function(result) {
        TranslatorService.translateText(model.t).then(function(res) {
          var languages = [
            'ja',
            'ko',
            'zh',
            'zh-TW'
          ]

          for (var i = 0; i < vm.levelsTranslations.length; i++) {
            for (var key in res.results) {
              if ((vm.levelsTranslations[i].comm === 'JP' && key === 'ja')) {
                languages.remove(key)
              }
              if ((vm.levelsTranslations[i].comm === 'KR' && key === 'ko')) {
                languages.remove(key)
              }
              if ((vm.levelsTranslations[i].comm === 'SC' && key === 'zh')) {
                languages.remove(key)
              }
              if ((vm.levelsTranslations[i].comm === 'TC' && key === 'zh-TW')) {
                languages.remove(key)
              }
            }
          }

          if (vm.title === model.t && languages.length === 0) {
            $timeout(function() {
              $state.go("admin.collector_levels");
            }, 250);
            return
          }

          if (vm.title !== model.t) {
            var promises = []
  
            for (var i = 0; i < vm.levelsTranslations.length; i++) {
              // if (vm.levelsTranslations[i]['id-u']) {
              //   continue
              // }
              if (vm.levelsTranslations[i].comm === 'SC' && res.results) {
                var exist = _.find(languages, 'zh');
                if (exist) {
                  promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': 0, comm: 'SC', t: res.results.zh }))
                } else {
                  promises.push(CollectorLevelService.updateTranslation(vm.levelsTranslations[i].id, { 'id-u': 0, t: res.results.zh  }))
                }
                continue
              }
              if (vm.levelsTranslations[i].comm === 'TC' && res.results) {
                var exist = _.find(languages, 'zh-TW');
                if (exist) {
                  promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': 0, comm: 'TC', t: res.results['zh-TW'] }))
                } else {
                  promises.push(CollectorLevelService.updateTranslation(vm.levelsTranslations[i].id, { 'id-u': 0, t: res.results['zh-TW'] }))
                }
                continue
              }
              if (vm.levelsTranslations[i].comm === 'KR' && res.results) {
                var exist = _.find(languages, 'ko');
                if (exist) {
                  promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': 0, comm: 'KR', t: res.results.ko }))
                } else {
                  promises.push(CollectorLevelService.updateTranslation(vm.levelsTranslations[i].id, { 'id-u': 0, t: res.results.ko }))
                }
                continue
              }
              if (vm.levelsTranslations[i].comm === 'JP' && res.results) {
                var exist = _.find(languages, 'ja');
                if (exist) {
                  promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': 0, comm: 'JP', t: res.results.ja }))
                } else {
                  promises.push(CollectorLevelService.updateTranslation(vm.levelsTranslations[i].id, { 'id-u': 0, t: res.results.ja }))
                }
                continue
              }
            }
            
            $q.all(promises).then(function(){
              $timeout(function() {
                $state.go("admin.collector_levels");
              }, 250);
            }).catch(function(err){
              swal("Error in translation, please send message to qp2 administrator!", "", "error");
            })
          }

          var promises = []

          for (var i = 0; i < languages.length; i++) {
            if (languages[i] === 'zh' && res.results) {
              promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': null, comm: 'SC', t: res.results.zh }))
            }
            if (languages[i] === 'zh-TW' && res.results) {
              promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': null, comm: 'TC', t: res.results['zh-TW'] }))
            }
            if (languages[i] === 'ko' && res.results) {
              promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': null, comm: 'KR', t: res.results.ko }))
            }
            if (languages[i] === 'ja' && res.results) {
              promises.push(CollectorLevelService.saveTranslation($stateParams.id, { 'id-u': null, comm: 'JP', t: res.results.ja }))
            }
          }

          $q.all(promises).then(function(){
            $timeout(function() {
              $state.go("admin.collector_levels");
            }, 250);
          }).catch(function(){
            swal("Error in translation, please send message to qp2 administrator!", "", "error");
          })
        });
      });
    };

    vm.cancel = function() {
      $state.go("admin.collector_levels");
    };

    vm.uploadH = function(item) {
      if (vm.pathImgH.type === "image/tiff") {
        swal("Unsupported extension", "", "warning");
        return;
      }

      vm.loadH = true;
      UploadService.save("collector_levels", vm.pathImgH, "img", item.id).then(function(
        fileName
      ) {
        vm.loadH = false;
        item.img = fileName;
      });
    };

    vm.levelsTranslations = [];
    vm.translate = {}
    vm.pathImgTranslation = "";
    vm.loadTranslation = false;
    vm.addTranslate = function(){
      vm.translate = {};
      $("#modalTranslate").modal("show");
    };

    function loadTranslations() {
      CollectorLevelService.listTranslations($stateParams.id).then(function(result) {
        vm.levelsTranslations = result.results;
      });
    }

    loadTranslations();

    vm.classDisabled = function(){
      if (!vm.translate.comm || !vm.translate.t){
        return 'is-disabled';
      } else {
        return;
      }
    };

    vm.saveTranslate = function() {
      if (vm.translate.id) {
        CollectorLevelService.updateTranslation(vm.translate.id, vm.translate).then(function(){
          loadTranslations();
          vm.translate = {};
          $("#modalTranslate").modal("hide");
        }, function(err){
          swal(err.error.message, "", "error");
        });
      } else {
        CollectorLevelService.saveTranslation($stateParams.id, vm.translate).then(function(){
          loadTranslations();
          vm.translate = {};
          $("#modalTranslate").modal("hide");
        }, function(err){
          swal(err.error.message, "", "error");
        });
      }
    };

    vm.editTranslate = function(id) {
      CollectorLevelService.getTranslation(id).then(function(result){
        vm.translate = result.results;
        $("#modalTranslate").modal("show");
      }, function(err){
        swal(err.error.message, "", "error");
      });
    };

    vm.deleteTranslate = function(id) {
      swal({
        title: "Are you sure?",
        text: "",
        type: "warning",
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: "slide-from-top"
      }, function(isConfirm){
        if (isConfirm){
          CollectorLevelService.removeTranslation(id).then(function(){
            loadTranslations();
            vm.translate = {};
            $("#modalTranslate").modal("hide");
          }, function(err){
            $timeout(function(){
              swal(err.error.message, "", "error");
            }, 500);
          });
        } else {
          return;
        }
      });
    };

    vm.uploadTranslation = function(item) {
      vm.loadTranslation = true;
      UploadService.save("collector_levels", vm.pathImgTranslation, "img", item.id).then(function(
        fileName
      ) {
        vm.loadTranslation = false;
        item.img = fileName;
      });
    };
  }
})();
